import React from 'react'
import PropTypes from 'prop-types'

import loadable from '@loadable/component'

import SanityResponsiveImage from '../SanityResponsiveImage'

const Carousel = loadable(() => import('./Carousel'))
const Shape = loadable(() => import('./Shape'))
const BookingSearch = loadable(() => import('../BookingSearch'))

const GalleryMobile = ({ bgImg, gallery, priority = false }) => {
  let featuredImage
  // Coded by Shane. I don't like it but it works.
  if (bgImg !== null) {
    if (typeof bgImg.asset !== 'undefined') {
      featuredImage = bgImg
    } else {
      featuredImage = gallery.images.find(image => image.featured)
    }
  } else {
    featuredImage = gallery.images.find(image => image.featured)
  }

  return (
    <div className="ratio-mobile-gallery">
      <div className="text-gray-100 inner">
        {bgImg && !gallery && (
          <SanityResponsiveImage
            image={featuredImage}
            className="absolute inset-0 object-cover h-full"
            alt={featuredImage.alt}
            width={768}
            height={891}
            widths={[320, 500, 768]}
            sizes="100vw"
            priority={priority}
            media={priority ? '(max-width: 767.98px)' : undefined}
          />
        )}
        {gallery && <Carousel images={gallery?.images} isMobile priority={priority} />}
        <Shape heading />
      </div>
    </div>
  )
}

GalleryMobile.propTypes = {
  gallery: PropTypes.object,
  bgImg: PropTypes.object,
}

GalleryMobile.defaultProps = {
  gallery: {},
  bgImg: null,
}

export default GalleryMobile
